<template>
  <div
    v-if="!record.isTotalRow"
    class="orders-number-cell"
    :class="{
      'orders-number-cell-not-clickable':
        !canEdit ||
        (record.orders && record.orders.value == 0) ||
        (record.number_of_orders && record.number_of_orders.value == 0),
    }"
    @click="clickHandler"
  >
    <c-sidesheet class="orders-number-cell-sidesheet" :active="isShowOrdersModal" @close="closeOrdersModal">
      <svg
        class="orders-number-cell-sidesheet-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closeOrdersModal"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="orders-number-cell-sidesheet-title">
        <div class="orders-number-cell-sidesheet-title-desc">Заказы водителя</div>
        <div class="d-flex align-items-center">
          <router-link
            target="_blank"
            :to="{
              name: 'personal-employee-summary',
              params: { id: currentDriverLocalValue !== null ? currentDriverLocalValue.value : record.id },
            }"
            class="orders-number-cell-sidesheet-title-employee"
          >
            {{ currentDriverLocalValue !== null ? currentDriverLocalValue.label : record.employee.value }}
          </router-link>
          <c-button-dropdown
            icon="arrow"
            type="dropdown"
            class="orders-number-cell-sidesheet-title-dropdown"
            :dropdown="{
              position: 'left',
              items: driversLocalItems,
            }"
            @changeWorker="changeWorker"
          />
        </div>
      </div>
      <c-tabs
        ref="tabs"
        class="orders-number-cell-sidesheet-tabs"
        :active="activeTab"
        :items="tabs.items"
        @change="changeTab"
      />
      <div class="position-relative h-100">
        <div
          id="orders-number-cell-sidesheet-table-shadow-top"
          class="orders-number-cell-sidesheet-table-shadow-top"
        ></div>
        <div
          id="orders-number-cell-sidesheet-table"
          class="orders-number-cell-sidesheet-table"
          @scroll="setShadowsOnScroll"
        >
          <div v-if="isDataLoading" class="orders-number-cell-sidesheet-table-loader">
            <font-awesome-icon :icon="icon" spin />
          </div>
          <c-table-data-orders
            v-if="!isDataLoading"
            ref="table"
            class="orders-number-cell-sidesheet-table-table"
            empty-records-label="Записи не найдены"
            :levels="1"
            :disabled-columns="tableData.disabledColumns"
            :is-show-nested-orders-in-routes-tab="true"
            :data="tableData"
            :active-tab="activeTab"
            @changeDriver="changeDriver"
            @recountDriver="recountDriver"
          />
        </div>
        <div
          id="orders-number-cell-sidesheet-table-shadow-bottom"
          class="orders-number-cell-sidesheet-table-shadow-bottom"
        ></div>
      </div>
    </c-sidesheet>
    <div class="orders-number-cell-value">
      {{ calculationType === "byPeriod" ? record.orders.value : record.number_of_orders.value }}
    </div>
  </div>
  <div v-else class="orders-number-cell-sum-row">
    {{ calculationType === "byPeriod" ? record.orders.value : record.number_of_orders.value }}
  </div>
</template>
<script>
import moment from "moment";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ButtonDropdown from "@/components/controls/button-dropdown";
import Sidesheet from "@/components/sidesheet";
import Tabs from "@/components/tabs";
import DataTableOrders from "@/pages/calculations/create/additions/sidesheet-additions/data-table-orders";

export default {
  name: "delivery-number-of-orders-cell",
  components: {
    "c-sidesheet": Sidesheet,
    "c-tabs": Tabs,
    "c-table-data-orders": DataTableOrders,
    "c-button-dropdown": ButtonDropdown,
    FontAwesomeIcon,
  },
  props: ["record", "calculationData", "calculationType", "canEdit"],
  data() {
    return {
      icon: faSpinner,
      isShowOrdersModal: false,
      isDataLoading: true,
      tabs: {
        items: [
          { label: "Заказы", value: "orders" },
          { label: "Рейсы", value: "routes" },
        ],
      },
      driversLocalItems: [],
      currentDriverLocalValue: null,
      activeTab: "orders",
      ordersTableColumns: [
        {
          id: "order_number",
          label: "Номер заказа",
          fullName: "Номер заказа",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "delivery_time",
          label: "Время доставки",
          fullName: "Время доставки",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "summ_order",
          label: "Сумма заказа, ฿",
          fullName: "Сумма заказа, ฿",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "processed",
          label: "Обработал",
          fullName: "Обработал",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
      ],
      ordersRecords: [
        {
          order_number: {
            value: "16567",
          },
          delivery_time: {
            value: "1 ч 4 мин",
          },
          summ_order: {
            value: 900,
          },
          processed: {
            value: "Булекова Ольга",
          },
          isShowRow: true,
          orderList: {
            sum: 1200,
            items: [
              { name: "Картошка с говядиной", count: 1, summ: 100 },
              { name: "Картошка с курицей", count: 2, summ: 100 },
              { name: "Пицца фермерская", count: 3, summ: 150 },
              { name: "Вилка", count: 4, summ: 100 },
            ],
          },
          historyChanges: [
            { desc: "Создан", time: "11:09" },
            { desc: "Открыт", time: "11:09" },
            { desc: "Распечатан", time: "11:09" },
            { desc: "Приготовлен", time: "11:09" },
          ],
          operator: "Буренкова Ольга",
          delivery: {
            when_delivered: "12:09 03.04.2020",
            elapsed_time: "12 мин",
            point: "г. Ленинский городской округ, раб. пос. Боброво, ул. Крымская, д. 15",
          },
        },
        {
          order_number: {
            value: "16011",
          },
          delivery_time: {
            value: "19 мин",
          },
          summ_order: {
            value: 1339,
          },
          processed: {
            value: "Майорова Дарь",
          },
          isShowRow: true,
          orderList: {
            sum: 1200,
            items: [
              { name: "Картошка с говядиной", count: 1, summ: 100 },
              { name: "Картошка с курицей", count: 2, summ: 100 },
              { name: "Пицца фермерская", count: 3, summ: 150 },
              { name: "Вилка", count: 4, summ: 100 },
            ],
          },
          historyChanges: [
            { desc: "Создан", time: "11:09" },
            { desc: "Открыт", time: "11:09" },
            { desc: "Распечатан", time: "11:09" },
            { desc: "Приготовлен", time: "11:09" },
          ],
          operator: "Буренкова Ольга",
          delivery: {
            when_delivered: "12:09 03.04.2020",
            elapsed_time: "12 мин",
            point: "г. Ленинский городской округ, раб. пос. Боброво, ул. Крымская, д. 15",
          },
        },
        {
          order_number: {
            value: "16567",
          },
          delivery_time: {
            value: "1 ч 4 мин",
          },
          summ_order: {
            value: 900,
          },
          processed: {
            value: "Булекова Ольга",
          },
          isShowRow: true,
          orderList: {
            sum: 1200,
            items: [
              { name: "Картошка с говядиной", count: 1, summ: 100 },
              { name: "Картошка с курицей", count: 2, summ: 100 },
              { name: "Пицца фермерская", count: 3, summ: 150 },
              { name: "Вилка", count: 4, summ: 100 },
            ],
          },
          historyChanges: [
            { desc: "Создан", time: "11:09" },
            { desc: "Открыт", time: "11:09" },
            { desc: "Распечатан", time: "11:09" },
            { desc: "Приготовлен", time: "11:09" },
          ],
          operator: "Буренкова Ольга",
          delivery: {
            when_delivered: "12:09 03.04.2020",
            elapsed_time: "12 мин",
            point: "г. Ленинский городской округ, раб. пос. Боброво, ул. Крымская, д. 15",
          },
        },
        {
          order_number: {
            value: "16567",
          },
          delivery_time: {
            value: "1 ч 4 мин",
          },
          summ_order: {
            value: 900,
          },
          processed: {
            value: "Булекова Ольга",
          },
          isShowRow: true,
          orderList: {
            sum: 1200,
            items: [
              { name: "Картошка с говядиной", count: 1, summ: 100 },
              { name: "Картошка с курицей", count: 2, summ: 100 },
              { name: "Пицца фермерская", count: 3, summ: 150 },
              { name: "Вилка", count: 4, summ: 100 },
            ],
          },
          historyChanges: [
            { desc: "Создан", time: "11:09" },
            { desc: "Открыт", time: "11:09" },
            { desc: "Распечатан", time: "11:09" },
            { desc: "Приготовлен", time: "11:09" },
          ],
          operator: "Буренкова Ольга",
          delivery: {
            when_delivered: "12:09 03.04.2020",
            elapsed_time: "12 мин",
            point: "г. Ленинский городской округ, раб. пос. Боброво, ул. Крымская, д. 15",
          },
        },
      ],
      routesTableColumns: [
        {
          id: "route",
          label: "Маршрут",
          fullName: "Маршрут",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "start_end",
          label: "Начало/завершение",
          fullName: "Начало/завершение",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "distance",
          label: "Дистанция, км",
          fullName: "Дистанция, км",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "estimated_actual_travel_time",
          label: "Расч./факт. время в пути",
          fullName: "Расч./факт. время в пути",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
      ],
      routesTableRecords: [
        {
          route: {
            value: 0,
          },
          start_end: {
            value: 0,
          },
          distance: {
            value: 0,
          },
          estimated_actual_travel_time: {
            value: 0,
          },
        },
        {
          route: {
            value: 0,
          },
          start_end: {
            value: 0,
          },
          distance: {
            value: 0,
          },
          estimated_actual_travel_time: {
            value: 0,
          },
        },
        {
          route: {
            value: 0,
          },
          start_end: {
            value: 0,
          },
          distance: {
            value: 0,
          },
          estimated_actual_travel_time: {
            value: 0,
          },
        },
        {
          route: {
            value: 0,
          },
          start_end: {
            value: 0,
          },
          distance: {
            value: 0,
          },
          estimated_actual_travel_time: {
            value: 0,
          },
        },
      ],
      tableData: {
        type: "delivery-orders-table",
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        disabledColumns: [],
        defaultDisabledColumns: [],
        filteredColumns: [],
        activeFilteredColumns: [],
      },
    };
  },
  watch: {
    isShowOrdersModal(value) {
      if (value) {
        this.tableData.columns = this.ordersTableColumns;

        this.driversLocalItems = [];
        if (this.calculationType === "byPeriod") {
          this.driversLocalItems = this.calculationData.period.drivers.workers.map((worker) => ({
            value: worker.worker_id,
            label: worker.showname,
            emit: "changeWorker",
          }));
        } else {
          this.driversLocalItems = this.calculationData.calc.drivers.workers.map((worker) => ({
            value: worker.worker_id,
            label: worker.showname,
            emit: "changeWorker",
          }));
        }

        const findCurrentDriverIndex = this.driversLocalItems.findIndex((driver) => driver.value === this.record.id);
        if (findCurrentDriverIndex !== -1)
          this.currentDriverLocalValue = this.driversLocalItems[findCurrentDriverIndex];

        this.getWorkerOrderRoutesData(this.record.id);
      }
    },
  },
  methods: {
    changeDriver(record)  {
      this.$emit("changeDriver", record);
    },

    recountDriver(record)  {
      this.$emit("recountDriver", this.record);
      this.$emit("close");
      setTimeout(() => {
        this.isShowOrdersModal = false;
      }, 150);
    },

    clickHandler() {
      if (!this.canEdit) {
        return;
      }
      if (this.calculationType === "byPeriod" || true) {
        if (this.record.orders.value || this.record.number_of_orders.value) {
          this.isShowOrdersModal = true;
        }
      }
    },
    setShadowsOnScroll() {
      const shadowBottomElement = document.getElementById("orders-number-cell-sidesheet-table-shadow-bottom");
      const shadowTopElement = document.getElementById("orders-number-cell-sidesheet-table-shadow-top");
      const scrollElement = document.getElementById("orders-number-cell-sidesheet-table");
      if (scrollElement !== null) {
        // if container scrollable
        if (scrollElement.scrollHeight > scrollElement.clientHeight) {
          // top shadow handler
          if (scrollElement.scrollTop !== 0) {
            shadowTopElement.classList.add("orders-number-cell-sidesheet-table-shadow-top-active");
          } else if (scrollElement.scrollTop === 0) {
            shadowTopElement.classList.remove("orders-number-cell-sidesheet-table-shadow-top-active");
          }
          // bottom shadow handler
          if (scrollElement.scrollTop + scrollElement.clientHeight !== scrollElement.scrollHeight) {
            shadowBottomElement.classList.add("orders-number-cell-sidesheet-table-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("orders-number-cell-sidesheet-table-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("orders-number-cell-sidesheet-table-shadow-top-active");
          shadowBottomElement.classList.remove("orders-number-cell-sidesheet-table-bottom-active");
        }
      }
    },
    changeTab(value) {
      if (value === "orders") {
        this.isDataLoading = true;
        this.activeTab = "orders";
        this.tableData.columns = this.ordersTableColumns;
        this.tableData.records = this.ordersRecords;
        this.isDataLoading = false;
      } else {
        this.isDataLoading = true;
        this.activeTab = "routes";
        this.tableData.columns = this.routesTableColumns;
        this.tableData.records = this.routesTableRecords;
        this.isDataLoading = false;
      }
    },
    closeOrdersModal() {
      this.$emit("close");
      setTimeout(() => {
        this.isShowOrdersModal = false;
      }, 150);
    },
    getTimeDifference(start, end) {
      const startTime = moment(start, "HH:mm");
      const endTime = moment(end, "HH:mm");

      const duration = moment.duration(endTime.diff(startTime));

      const hours = parseInt(duration.asHours(), 10);

      const minutes = parseInt(duration.asMinutes(), 10) % 60;

      if (hours > 0) return `${hours}ч ${minutes} мин`;
      return `${minutes} мин`;
    },
    changeWorker(workerId) {
      this.isDataLoading = true;
      const findCurrentDriverIndex = this.driversLocalItems.findIndex((driver) => driver.value === workerId);
      if (findCurrentDriverIndex !== -1) this.currentDriverLocalValue = this.driversLocalItems[findCurrentDriverIndex];
      this.getWorkerOrderRoutesData(workerId);
    },

    getWorkerOrderRoutesData(workerId) {
      let filialId = "";
      let date = "";
      let dateend = "";

      if (this.calculationType === "byPeriod") {
        filialId = this.calculationData.period.calculation.filialID
          ? this.calculationData.period.calculation.filialID
          : this.calculationData.period.calculation.filial_id;
        date = moment(this.calculationData.period.calculation.datetime).format("DD.MM.YYYY");
        dateend = moment(this.calculationData.period.calculation.datetime_end).format("DD.MM.YYYY");
      } else {
        filialId = this.calculationData.calc.calculation.filial_id;
        date = this.calculationData.calc.calculation.date;
      }

      this.$store
        .dispatch("calculations/getOrdersRoutesData", {
          filialId,
          workerId,
          date,
          dateend,
        })
        .then((res) => {
          this.ordersRecords = [];
          const orders = [];
          const routes = [];
          res.routes.forEach((route) => {
            let strp = "-", strf="-";
            let p = route.plan_duration;
            if (p) {
              strp = "";
              let h  = Math.floor(p/3600)
              if (h) strp = h + " ч. ";
              let m = Math.round((p-h*3600)/60);
              strp += (m+" мин");
            }
            p = route.duration;
            if (p) {
              strf = "";
              let h  = Math.floor(p/3600)
              if (h) strf = h + " ч. ";
              let m = Math.round((p-h*3600)/60);
              strf += (m+" мин");
            }
            routes.push({
              route: {
                value: route.orders.map((order) => order.delivery.address).join("<br>"),
              },
              start_end: {
                value: `${route.date} ${route.start_time}<br>` + (route.end_time!==null ? `${route.date} ${route.end_time}` : '&ndash;'),
              },
              distance: {
                value: Math.round(route.distance/1000*100)/100,
              },
              estimated_actual_travel_time: {
                value: strp + " / " +strf,
              },
              orders: route.orders,
              drivers: this.driversLocalItems,
              currentDriver: this.currentDriverLocalValue,
            });
          });

          res.orders.forEach((order) => {
            orders.push({
              warning: order.warning,
              id : order.id,
              operator: order.operator,
              order_number: {
                value: order.number.toString(),
              },
              delivery_time: {
                value: order.fact_time,
              },
              summ_order: {
                value: order.sum,
              },
              processed: {
                value: order.operator,
              },
              orderList: {
                sum: order.sum,
                items: order.items.map((item) => ({
                  name: item.name,
                  count: `${item.amount} шт.`,
                  summ: `${Math.round(item.sum)} ฿`,
                })),
              },
              historyChanges: order.history.map((item) => ({
                desc: item.n,
                time: item.t,
                d:  item.d,
              })),
              delivery: {
                when_delivered: `${order.delivery.time[0]} ${order.delivery.time[1]}`,
                elapsed_time: this.getTimeDifference(order.start_time, order.close_time),
                point: order.delivery.address,
              },
              drivers: this.driversLocalItems,
              currentDriver: this.currentDriverLocalValue,
              isShowRow: true,
            });
          });
          this.ordersRecords = [...orders];
          this.routesTableRecords = [...routes];

          if (this.activeTab === "orders") {
            this.tableData.records = [...orders];
          } else {
            this.tableData.records = [...routes];
          }

          setTimeout(() => {
            this.isDataLoading = false;
          }, 300);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.orders-number-cell {
  height: 100%;

  &-not-clickable {
    pointer-events: none;
    & .orders-number-cell-value {
      color: #8e9cbb !important;
    }
  }

  &-sum-row {
    line-height: 13px;
    font-size: 13px;
    padding: 10px;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &-sidesheet {
    position: relative;

    ::v-deep .sidesheet__header {
      flex-basis: 0;
    }

    ::v-deep .sidesheet__wrapper {
      width: calc(100vw - 161px);
      padding: 38px 14px 38px 31px;

      @media screen and (max-width: 1024px) {
        width: calc(100vw - 62px);
      }

      @media screen and (max-width: 700px) {
        padding: 28px 20px;
        max-width: 100%;
        width: 100%;
      }
    }

    &-close {
      position: absolute;
      top: 12px;
      right: 12px;
      display: none;

      @media screen and (max-width: 700px) {
        display: block;
      }
    }

    &-title {
      display: flex;
      align-items: center;

      @media screen and (max-width: 700px) {
        flex-direction: column;
        align-items: flex-start;
      }

      &-desc {
        font-weight: 500;
        font-size: 22px;
        line-height: 108%;

        @media screen and (max-width: 700px) {
          margin-bottom: 5px;
          font-weight: 500;
          font-size: 18px;
          line-height: 108%;
        }
      }

      &-employee {
        font-weight: 500;
        font-size: 22px;
        line-height: 108%;
        color: #0066ff;
        margin-left: 12px;

        @media screen and (max-width: 700px) {
          font-weight: 500;
          font-size: 18px;
          line-height: 108%;
          margin-left: 0;
        }

        &:hover {
          text-decoration: none;
          color: #003f9d;
        }
      }

      &-dropdown {
        &::v-deep .c-button__wrapper {
          border: 0;
          padding-left: 7px;
        }

        &::v-deep .c-button__dropdown__container {
          min-width: 160px;
          max-width: 500px;
          width: 350px;
        }

        &::v-deep .c-button__dropdown__container__list__item {
          padding: 1px 14px;
        }
      }
    }

    &-tabs {
      margin-top: 24px;

      &::v-deep .c-tabs-shadow {
        left: -30px;
      }

      @media screen and (max-width: 700px) {
        margin-top: 16px;
      }
    }

    &-table {
      margin-top: 29px;
      width: 100%;
      max-height: calc(100% - 75px);
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: 16px;

      @media screen and (max-width: 700px) {
        margin-left: -20px;
        width: calc(100% + 40px);
      }

      &-shadow-top {
        position: absolute;
        top: 0;
        left: 0;
        background: transparent;
        z-index: 100;
        opacity: 0;
        pointer-events: none;
        height: 30px;
        width: 100%;

        &-active {
          background: -webkit-gradient(
            linear,
            left bottom,
            left top,
            color-stop(16.13%, rgba(255, 255, 255, 0)),
            color-stop(100%, #ffffff)
          );
          opacity: 1;
        }
      }

      &-shadow-bottom {
        position: absolute;
        background: transparent;
        bottom: 75px;
        left: 0;
        z-index: 100;
        pointer-events: none;
        height: 30px;
        width: 100%;
        opacity: 0;
        transition: 0.2s;

        &-active {
          opacity: 1;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
        }
      }

      &::-webkit-scrollbar {
        width: 4px;
        height: 100%;
      }

      &::-webkit-scrollbar-thumb {
        background: $color-secondary;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        background: $color-border-alt;
      }

      &-table {
        width: 100%;

        @media screen and (max-width: 700px) {
          width: calc(100% + 20px);
          margin-left: 0 !important;
        }

        &::v-deep .c-table__wrapper {
          @media screen and (max-width: 700px) {
            max-width: calc(100% + 60px);
          }
        }

        &::v-deep .c-table__cell,
        &::v-deep .c-table__column {
          position: static !important;
        }

        &::v-deep td:after {
          background: #ffffff !important;
        }
      }

      &-loader {
        display: flex;
        font-size: 32px;
        width: 100%;
        height: 100%;
        justify-content: center;
        color: #ff238d;
      }
    }
  }

  &-value {
    line-height: 13px;
    font-size: 13px;
    padding: 10px;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    color: #0066ff;
    cursor: pointer;
  }
}
</style>
